var _defs, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyPhoneNumbersTable(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 500,
    height: 500,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: -2223.69,
    y1: -4875.89,
    x2: -2217.91,
    y2: -4865.87,
    gradientTransform: "rotate(120 -2507.402 -1569.996)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bdbdbd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8b8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m202.16 323.8-86.83-50.58a4.14 4.14 0 0 1-2.35-3.31c.09 1.45-.33 8.92.6 10.09a5.47 5.47 0 0 0 1.75 1.53l86.84 50.59Z",
    style: {
      fill: "#8b8b8b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.61 233.46a4.76 4.76 0 0 0 2.27-2.45c.28-.61.1-8.56.14-9.24a2.83 2.83 0 0 1-.15.9 4.85 4.85 0 0 1-2.26 2.45l-170.88 98.67v8.33Z",
    style: {
      fill: "#bdbdbd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.73 323.79a12.75 12.75 0 0 1-11.57 0l-86.83-50.58c-3.16-1.83-3.14-4.84.07-6.7l170.87-98.65a12.72 12.72 0 0 1 11.54 0l86.83 50.58c3.19 1.85 3.17 4.83 0 6.68Z",
    style: {
      fill: "#a3a3a3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.06 324.82a13.69 13.69 0 0 1-7.61-.41 10.07 10.07 0 0 1-1.28-.61v8.33a8.66 8.66 0 0 0 1.27.6 13 13 0 0 0 10.28-.62v-8.33a10.27 10.27 0 0 1-2.66 1.04Z",
    style: {
      fill: "url(#a)"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M213.88 323.19a12.72 12.72 0 0 1-11.57 0l-85.95-50.07c-3.16-1.84-3.14-4.85.07-6.7l169.7-98a12.81 12.81 0 0 1 11.54 0l85.95 50.07c3.18 1.85 3.14 4.85 0 6.69Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M212.12 320.91a8.89 8.89 0 0 1-8 0l-84.84-49.43c-1.58-.92-1.58-2.42 0-3.36l168.61-97.34a8.86 8.86 0 0 1 8 0l84.82 49.41c1.61.93 1.57 2.45 0 3.37Z",
    style: {
      fill: "#c3ddff"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M341.89 202.94a1.08 1.08 0 0 1 0 2.05 3.89 3.89 0 0 1-3.53 0l-20.72-12a1.08 1.08 0 0 1 0-2 3.9 3.9 0 0 1 3.52 0Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyPhoneNumbersTable);
export default __webpack_public_path__ + "static/media/empty_phone_numbers_table.eb02a5b2211821c515963845a5422918.svg";
export { ForwardRef as ReactComponent };